'use client';

import {createContext, useContext} from 'react';
import {SiteSettingFieldsFragment} from '@common/hygraph-schema';

export const DEFAULT_SITE_SETTINGS: SiteSettingFieldsFragment = {
	__typename: 'SiteSetting',
	siteBannerEnabled: false
};

type SiteSettingsContextType = SiteSettingFieldsFragment & {cmsRedeemDisabled: boolean};

export const SiteSettingsContext = createContext<SiteSettingsContextType>({
	...DEFAULT_SITE_SETTINGS,
	cmsRedeemDisabled: false
});

export function useSiteSettingsContext(): SiteSettingsContextType {
	return useContext(SiteSettingsContext);
}
